import FileSvg from '@assets/images/svg/file.svg';
import React from 'react';

export interface FileIconProps {
    size?: number;
    color?: string;
}

export function FileIcon({ size = 24, color = '#333333' }: FileIconProps) {
    return (
        <FileSvg width={size} height={size} color={color} />
    );
}

export default FileIcon;
